import type { FaireProductEntity } from "../../entity_types/product";

export const p_rq3tvqm7xt: FaireProductEntity = {
  token: "p_rq3tvqm7xt",
  type: "product",
  name: "10 Commandments Wooden Puzzle",
  brandToken: "b_2dve4egfbx",
  brandName: "The Shoppe at Little Creek",
  imageUrl:
    "https://cdn.faire.com/fastly/8ff4d9285abae78b1d072246e86f999efed586ad57e0b4a01aa42b90ba5c1b9f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b59d9e35f0e9c7e9e146c9c057028fda7b527efb231eccde59a9e4d35db4c910.jpeg",
    "https://cdn.faire.com/fastly/0b85c8244cc9b6d8c5b6bf1d7aa619f0a6cf4d577e6b29b34369e858d5992966.jpeg",
    "https://cdn.faire.com/fastly/a29d090a42c8423c33f1280fb48f0f0edbb272b28aed4cf009688193b10e7b71.jpeg",
    "https://cdn.faire.com/fastly/b1d6e4c7bb9e6476f7b54331ca8565530746caf02a4d64da3c6466d7fcb9a266.jpeg",
  ],
  priceDollars: 34.63,
  description:
    'Our 10 Commandments puzzle offers amazing tools for children to learn their numbers along with learning the 10 Commandments from the bible.\nAmazing durable wooden puzzle to assist in teaching children about God\'s love.\n- Puzzle is 9.25" by 11"\n- Pieces are 1/2" thick and raised for easy removal for little fingers. \n- Laser cut maple wood\n- UV printed for non- toxic lasting durability \n- All Pieces meet CPSC choking hazard standards\n- Each puzzle is shrink wrapped for a beautiful display',
  tags: [],
  msrpDollars: 69.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:19.741Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
